module.exports = __webpack_public_path__ + "img/chevron_right.38e1cd39.svg";